export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_04_01_loop.93b8f1a2.mp4";